(function() {
  var scrollBtn = document.getElementById('hero-scroll-btn');
  if (scrollBtn) {
    scrollBtn.addEventListener('click', function() {
      var hero = document.querySelector('.hero');
      if (hero) {
        var heroBottom = hero.offsetTop + hero.offsetHeight - 100;
        window.scrollTo({
          top: heroBottom,
          behavior: 'smooth'
        });
      }
    });
  }
})();
